import {
 Component,
 computed,
 DestroyRef,
 ElementRef,
 HostListener,
 inject,
 Inject,
 OnInit,
 ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { HotelInfoUiService } from '../../services/hotel-info-ui.service';
import {
 VoteFiltersModel,
 Room,
 GetAllVotesPayloadModel,
 GetAllVotesEcolodgePayloadModel,
} from '@core/models/domains/comments';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@shared/shared.module';
import { ProgressbarComponent } from '@shared/components/progressbar/progressbar.component';
import { GetAllVotesResModel } from '@core/models/domains/comments';

import { MatBottomSheet, MatBottomSheetConfig } from '@angular/material/bottom-sheet';
import { LoadingService } from '@shared/services/loading.service';
import { WebEngageRepository } from '@core/services/repositories/webEngage.repository';
import { cdnUrl } from 'apps/ihowebsite/src/app/app.module';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Subject, takeUntil } from 'rxjs';
import { SearchBoxService } from '@shared/services/serach-box.service';
@Component({
 selector: 'iho-comments-modal',
 standalone: true,
 imports: [
  CommonModule,
  MatCheckboxModule,
  FormsModule,
  SharedModule,
  ProgressbarComponent,
  MatFormFieldModule,
  MatSelectModule,
  MatDialogModule,
 ],

 templateUrl: './comments-modal.component.html',
 styleUrls: ['./comments-modal.component.scss'],
})
export class CommentsModalComponent implements OnInit {
 selectedRoom: number = 0;
 selectedType: number = 0;
 loadingData = false;
 noData = false;
 showFiltersComments: boolean = false;
 showEmpty = false;
 showRemoveBtn = false;
 cdnUrl = cdnUrl;
 listVoteAll: any[] = [];
 pageSize: number = 10;
 destroy = BehaviorSubject<boolean>;
 pageIndex = 1;
 flagScroll = false;
 totallCount = 0;
 loadingScroll = false;
 filterTextsModel: string[] = [];
 filterScoreModel: number[] = [];
 filterSeasonsModel: number[] = [];
 @ViewChild('showFiltersCommentsTemplate') showFiltersCommentsTemplate!: any;
 @ViewChild('showFiltersScoreTemplate') showFiltersScoreTemplate!: any;
 @ViewChild('showFiltersDateTemplate') showFiltersDateTemplate!: any;
 @ViewChild('containerComments') containerComments!: ElementRef;
 modalData: any;
 guestScore = [
  { id: 1, title: '1 (ضعيف)', selected: false },
  { id: 2, title: '2 (متوسط)', selected: false },
  { id: 3, title: '3 (خوب)', selected: false },
  { id: 4, title: '4 (بسيار خوب)', selected: false },
  { id: 5, title: '5 (عالى)', selected: false },
 ];
 historyComments = [
  { id: 1, title: 'فرودین تا خرداد', selected: false },
  { id: 2, title: 'تیر تا شهریور', selected: false },
  { id: 3, title: 'مهر تا آذر', selected: false },
  { id: 4, title: 'دی تا اسفند', selected: false },
 ];
 listRoomsFilters: any;
 constructor(
  @Inject(MAT_DIALOG_DATA) data: { data: any },
  public InfoService: HotelInfoUiService,
  public _bottomSheet: MatBottomSheet,
  public LoadingService: LoadingService,
  public dialogRef: MatDialogRef<CommentsModalComponent>,
  private webEngageRepository: WebEngageRepository,
  private destroyRef: DestroyRef
 ) {
  this.modalData = data;
 }
 @HostListener('scroll', ['$event'])
 onScroll(event: any) {
  if (
   event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight - 1 &&
   !this.flagScroll
  ) {
   this.pageIndex++;

   this.accommodation() == 'ecolodge'
    ? this.getVotesAllEcolodge('desk', this.pageSize, this.pageIndex)
    : this.getVotesAll('desk', this.pageSize, this.pageIndex);
  }
 }
 private searchBoxService = inject(SearchBoxService);
 accommodation = computed(() => this.searchBoxService.accommodation());

 ngOnInit(): void {
  if (this.accommodation() != 'ecolodge') {
   this.getFilters();
   this.getVotesAll('desk', this.pageSize, 1);
  } else {
   this.getVotesAllEcolodge('desk', this.pageSize, 1);
  }
 }
 closeModal() {
  this.dialogRef.close();
 }
 closeBottomSheet() {
  this._bottomSheet.dismiss();
 }
 getFilters() {
  this.InfoService.getVoteFilters(this.modalData.hid)
   .pipe(takeUntilDestroyed(this.destroyRef))
   .subscribe((res: any) => {
    this.listRoomsFilters = res;
   });
 }
 getVotesAll(type: string, pageSize: number, pageIndex: number) {
  if (type == 'mobile' && pageIndex == 1) {
   this.listVoteAll = [];
  }
  if (type == 'mobile' && pageIndex != 1) {
   pageIndex = 1;
  }
  let model: GetAllVotesPayloadModel = {
   hotelId: this.modalData.hid,
   pageIndex: pageIndex,
   pageSize: pageSize,
   travelType: this.selectedType,
   roomId: this.selectedRoom,
   filterTexts: this.filterTextsModel,
   voteScores: this.filterScoreModel,
   voteSeasons: this.filterSeasonsModel,
  };
  if (this.pageIndex == 1) this.loadingData = true;

  this.LoadingService.loadingState.set(true);
  this.flagScroll = true;
  if (this.listVoteAll.length == this.totallCount && this.totallCount != 0) {
   return;
  }

  this.loadingScroll = true;
  this.InfoService.getVoteAll(model).pipe(takeUntilDestroyed(this.destroyRef)).subscribe((res: any) => {
   this.totallCount = res.count;
   this.flagScroll = false;
   this.loadingScroll = false;
   this.loadingData = false;
   res.votes?.forEach((el: any) => {
    el.arrivalDate = new Date(el.arrivalDate).toLocaleDateString('fa-IR', {
     dateStyle: 'short',
     numberingSystem: 'latn',
    });
   });
   this.listVoteAll.push(...res.votes);
   if (this.listVoteAll?.length > 0) {
    this.LoadingService.loadingState.set(false);
   }
   this.showEmpty = false;
   if (res.votes?.length == 0) {
    this.showEmpty = true;
   }
   if (type == 'mobile') this.closeBottomSheet();
  });

  this.handleWebEngage(model);
 }
 getVotesAllEcolodge(type: string, pageSize: number, pageIndex: number) {
  if (this.noData) return;
  if (type == 'mobile' && pageIndex == 1) {
   this.listVoteAll = [];
  }
  if (type == 'mobile' && pageIndex != 1) {
   pageIndex = 1;
  }
  let model: GetAllVotesEcolodgePayloadModel = {
   hotelId: this.modalData.hid,
   HouseId: this.modalData.HouseId,
   PageIndex: pageIndex,
   PageSize: pageSize,
   Type: this.modalData.type,
  };
  if (this.pageIndex == 1) this.loadingData = true;

  this.LoadingService.loadingState.set(true);
  this.flagScroll = true;
  if (this.listVoteAll.length == this.totallCount && this.totallCount != 0) {
   return;
  }

  this.loadingScroll = true;
  this.InfoService.getVoteAllEcolodge(model).subscribe((res: any) => {
   this.totallCount = res.count;
   this.flagScroll = false;
   this.loadingScroll = false;
   this.loadingData = false;
   if (res.votes.length == 0) {
    this.noData = true;
    return;
   }
   res.votes?.forEach((el: any) => {
    el.arrivalDate = new Date(el.arrivalDate).toLocaleDateString('fa-IR', {
     dateStyle: 'short',
     numberingSystem: 'latn',
    });
   });
   this.listVoteAll.push(...res.votes);
   if (this.listVoteAll?.length > 0) {
    this.LoadingService.loadingState.set(false);
   }
   this.showEmpty = false;
   if (res.votes?.length == 0) {
    this.showEmpty = true;
   }
   if (type == 'mobile') this.closeBottomSheet();
  });

  //this.handleWebEngage(model);
 }

 handleWebEngage(model: GetAllVotesPayloadModel) {
  // const payload = {
  //   HotelName: this.modalData.HotelHeader.FullName,
  //   MoreReview: true,
  //   ReviewRate: this.modalData.HotelHeader.Score?.ScoreNumber,
  //   filterTexts: model.filterTexts,
  //   roomId: model.roomId,
  //   travelType: model.travelType,
  //   voteScores: model.voteScores,
  //   voteSeasons: model.voteSeasons
  // }
  // this.webEngageRepository.review(payload).subscribe(
  //   () => { }
  // )
 }

 selectedScore(id: number, type: string) {
  this.filterScoreModel = [];
  this.guestScore.forEach((item) => {
   if (item.id == id) {
    item.selected = !item.selected;
   }
   if (item.selected) {
    this.filterScoreModel.push(item.id);
   }
  });
  this.pageIndex = 1;
  if (type != 'mobile') {
   this.listVoteAll = [];
   this.getVotesAll('desk', this.pageSize, 1);
  }
  if (this.filterScoreModel?.length) this.showRemoveBtn = true;
  else this.showRemoveBtn = false;
 }
 selectedHistoryComments(id: number, type: string) {
  this.filterSeasonsModel = [];
  this.historyComments.forEach((item) => {
   if (item.id == id) {
    item.selected = !item.selected;
   }
   if (item.selected) {
    this.filterSeasonsModel.push(item.id);
   }
  });

  this.pageIndex = 1;
  if (type != 'mobile') {
   this.listVoteAll = [];
   this.getVotesAll('desk', this.pageSize, 1);
  }
  if (this.filterSeasonsModel?.length) this.showRemoveBtn = true;
  else this.showRemoveBtn = false;
 }
 selectedLabels(text: string, type: string) {
  this.filterTextsModel = [];
  this.listRoomsFilters.voteFilterLabels.forEach((item: any) => {
   if (item.name == text) {
    item.selected = !item.selected;
   }
   if (item.selected) {
    this.filterTextsModel.push(item.name);
   }
  });
  this.pageIndex = 1;
  if (type != 'mobile') {
   this.listVoteAll = [];
   this.getVotesAll('desk', this.pageSize, 1);
  }
  if (this.filterTextsModel?.length) this.showRemoveBtn = true;
  else this.showRemoveBtn = false;
 }
 selectedTypes(ev: any) {
  this.listVoteAll = [];
  this.pageIndex = 1;
  this.getVotesAll('desk', this.pageSize, 1);
  this.showRemoveBtn = true;
 }

 showFiltersSec(config?: MatBottomSheetConfig) {
  this._bottomSheet.open(this.showFiltersCommentsTemplate, config);
 }
 showFiltersScore(config?: MatBottomSheetConfig) {
  this._bottomSheet.open(this.showFiltersScoreTemplate, config);
 }
 showFiltersDate(config?: MatBottomSheetConfig) {
  this._bottomSheet.open(this.showFiltersDateTemplate, config);
 }
 removeFilters() {
  this.guestScore.forEach((item) => {
   item.selected = false;
  });
  this.historyComments.forEach((item) => {
   item.selected = false;
  });
  this.listRoomsFilters.voteFilterLabels.forEach((item: any) => {
   item.selected = false;
  });
  this.filterSeasonsModel = [];
  this.filterTextsModel = [];
  this.filterScoreModel = [];
  this.selectedType = 0;
  this.selectedRoom = 0;
  this.showRemoveBtn = false;
  this.listVoteAll = [];
  this.pageIndex = 1;
  this.getVotesAll('desk', this.pageSize, 1);
 }
}
